export enum ProjectStatus {
  OfferRequested = 'OfferRequested',
  OfferRequestAccepted = 'OfferRequestAccepted',
  OfferInProgress = 'OfferInProgress',
  OfferCreated = 'OfferCreated',
  AcceptanceCompleted = 'AcceptanceCompleted',
  FinalMeasurementInProgress = 'FinalMeasurementInProgress',
  FinalMeasurementCompleted = 'FinalMeasurementCompleted',
  Cancelled = 'Cancelled',
  Assigned = 'Assigned',
  OfferRequestRejected = 'OfferRequestRejected',
  OfferInReview = 'OfferInReview',
  OfferAccepted = 'OfferAccepted',
  OfferRejected = 'OfferRejected',
  Approved = 'Approved',
  FinalMeasurementInReview = 'FinalMeasurementInReview',
  FinalMeasurementAccepted = 'FinalMeasurementAccepted',
  Completed = 'Completed',
}
